var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player-detail"},[_c('player-info',{ref:"aiPlayer",attrs:{"captures":_vm.aiCaptures,"user-info":_vm.aiUserInfo}}),_c('player-info',{ref:"manPlayer",attrs:{"user-info":_vm.manUserInfo,"captures":_vm.manCaptures,"time":_vm.time},on:{"timeOver":_vm.manTimeOver}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }